import { type RefObject, useEffect } from 'react';

/**
 * Calls `handler` when a click/touch occurs outside the element referenced by `ref`.
 * Works reliably even inside `backdrop-filter` / `transform` stacking contexts
 * where `position: fixed` backdrops break.
 */
export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  handler: () => void,
  active = true,
): void {
  useEffect(() => {
    if (!active) return;

    const onPointerDown = (e: PointerEvent): void => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        handler();
      }
    };

    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, [ref, handler, active]);
}
